/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initMobileSliders() {
    // Only run on mobile
    if (window.innerWidth <= 749) {
      
      // Target ALL grids with mobile-slider class, including in tabs
      const allGrids = document.querySelectorAll('.grid--mobile-slider');
      
      console.log('Found ' + allGrids.length + ' grids with mobile-slider class');
      
      allGrids.forEach(function(grid) {
        const sliderWrapper = grid.closest('grid-slider');
        
        if (sliderWrapper && !sliderWrapper.classList.contains('tbs-css-slider')) {
          console.log('Processing grid:', grid);
          
          sliderWrapper.classList.add('tbs-css-slider');
          
          // Force styles directly
          grid.style.display = 'flex';
          grid.style.flexWrap = 'nowrap';
          grid.style.overflowX = 'auto';
          grid.style.webkitOverflowScrolling = 'touch';
          grid.style.scrollSnapType = 'x mandatory';
          grid.style.gap = '16px';
          grid.style.padding = '0 16px';
          
          console.log('Styles applied');
        } else if (!sliderWrapper) {
          // Handle grids not in grid-slider wrapper (like tabs)
          console.log('Grid without wrapper:', grid);
          
          grid.style.display = 'flex';
          grid.style.flexWrap = 'nowrap';
          grid.style.overflowX = 'auto';
          grid.style.webkitOverflowScrolling = 'touch';
          grid.style.scrollSnapType = 'x mandatory';
          grid.style.gap = '16px';
          grid.style.padding = '0 16px';
          grid.classList.add('tbs-css-slider-direct');
        }
      });
    }
  }

  // Run immediately and on DOM ready
  initMobileSliders();
  
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing sliders...');
    initMobileSliders();
    
    // Re-run after a delay to catch any late-loading content
    setTimeout(initMobileSliders, 500);
    setTimeout(initMobileSliders, 1000);
  });

  // Watch for tab clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-tab]')) {
      console.log('Tab clicked');
      setTimeout(initMobileSliders, 100);
    }
  });

  // Disable hover images on mobile and tablets (including iPad Pro landscape)
  if (window.innerWidth < 1440) {
    // Function to remove hover images from all product items
    function removeHoverImages() {
      // Remove all hover-images elements on mobile and tablets
      document.querySelectorAll('hover-images').forEach(function(el) {
        el.remove();
      });
      
      // Remove double__image class from ALL product items on the page
      document.querySelectorAll('.product-item__image.double__image').forEach(function(el) {
        el.classList.remove('double__image');
      });
    }
    
    // Run on DOM ready
    document.addEventListener('DOMContentLoaded', function() {
      removeHoverImages();
      
      // Run again after delays to catch dynamically loaded content (like product recommendations)
      setTimeout(removeHoverImages, 500);
      setTimeout(removeHoverImages, 1000);
      setTimeout(removeHoverImages, 2000);
    });
    
    // Also run immediately in case DOM is already loaded
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      removeHoverImages();
    }
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();